export default __webpack_public_path__ + "static/nav_img-f8af6887e351f477fab9305c3e93e1a4.png";